import BundleProvider from '../providers/BundleProvider'
import AddBenefitButton from '../components/AddBenefitButton/AddBenefitButton'

export default BundleProvider(AddBenefitButton)
